__turbopack_context__.v({
  "container": "FormPhoneNumberInput-module-scss-module__qar2qq__container",
  "invalid": "FormPhoneNumberInput-module-scss-module__qar2qq__invalid",
  "label": "FormPhoneNumberInput-module-scss-module__qar2qq__label",
  "phoneInput": "FormPhoneNumberInput-module-scss-module__qar2qq__phoneInput",
  "valid": "FormPhoneNumberInput-module-scss-module__qar2qq__valid",
});
